import axios from 'axios'
import Cookies from 'js-cookie';
const axiosInstance = axios.create({
    baseURL: 'https://dashboard.buildin.ae/api',

    headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Credentials": true,
        "Access-Control-Allow-Methods": "GET,HEAD,OPTIONS,POST,PUT",
    },

})

axiosInstance.interceptors.request.use(
    (config) => {
        const token = Cookies.get('token');

        if (token) {
            config.headers['Authorization'] = `Bearer ${token}`;
        }

        return config;
    },
    (error) => {
        console.log(error)
        return Promise.reject(error);
    }
);

export default axiosInstance;


